import React from 'react';

function UnauthorisedAccess() {
  return <div>Unauthorized Access</div>;
}

export default UnauthorisedAccess;
